import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import MultiStepRegistration from './components/MultiStepRegistration';
import UserLogin from './components/UserLogin';
import PasswordReset from './components/PasswordReset';
import EmailVerification from './components/EmailVerification';
import ProductPayment from './components/ProductPayment';
import PaymentSuccess from './components/PaymentSuccess';
import FirstPurchaseSuccess from './components/FirstPurchaseSuccess';
import TopUpSuccess from './components/TopUpSuccess';
import FirstPurchaseFailure from './components/FirstPurchaseFailure';
import TopUpFailure from './components/TopUpFailure';
import PaymentCancel from './components/PaymentCancel';
import UserDashboard from './components/UserDashboard';
import AdminDashboard from './components/AdminDashboard';
import AdminLogin from './components/AdminLogin';
import AdminUserProfile from './components/AdminUserProfile';
import RecordingDetail from './components/RecordingDetail';
import Layout from './components/Layout';
import NotFound from './components/NotFound';
import ButtonShowcase from './components/ButtonShowcase';
import OperatorPricingSection from './components/OperatorPricingSection';
import './styles/corporate-design.css';
import './styles/App.css';

// Page components with consistent layout
const Kainos: React.FC = () => (
  <Layout showDemo={true}>
    <div style={{ marginTop: '80px' }}>
      <OperatorPricingSection
        onGetStarted={(pkg) => {
          const orderId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
          window.location.href = `/registracija?minutes=${pkg.minutes}&price=${pkg.price}&orderId=${orderId}`;
        }}
      />
    </div>
  </Layout>
);

const OldKainos: React.FC = () => (
  <Layout showDemo={true}>
    <section style={{
      marginTop: '120px',
      padding: '4rem 0',
      background: 'linear-gradient(135deg, var(--neutral-light) 0%, var(--neutral-border) 100%)',
      minHeight: 'calc(100vh - 300px)'
    }}>
      <div className="container">
        <div className="section-header" style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 className="section-title" style={{
            color: '#000042',
            fontSize: '3rem',
            marginBottom: '1rem',
            fontFamily: 'Georgia, serif'
          }}>
            💰 Kainos ir Planai
          </h1>
          <p style={{
            fontSize: '1.2rem',
            color: '#666',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            Pasirinkite planą, kuris labiausiai tinka jūsų verslo poreikiams. Visi planai apima pilną funkcionalumą.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '2rem',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          {/* Basic Plan */}
          <div style={{
            background: 'white',
            border: '2px solid #e9ecef',
            borderRadius: '8px',
            padding: '2.5rem',
            textAlign: 'center',
            position: 'relative',
            transition: 'all 0.3s ease'
          }}>
            <h3 style={{
              fontFamily: 'Georgia, serif',
              color: '#000042',
              fontSize: '1.8rem',
              marginBottom: '1rem'
            }}>
              Bazinis
            </h3>
            <div style={{ marginBottom: '1rem' }}>
              <span style={{
                fontSize: '3rem',
                fontWeight: 'bold',
                color: '#000042',
                fontFamily: 'Georgia, serif'
              }}>€29</span>
              <span style={{ color: '#666', fontSize: '1rem' }}>/mėn</span>
            </div>
            <p style={{ color: '#666', marginBottom: '2rem' }}>
              Idealus pradedantiesiems
            </p>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              marginBottom: '2rem',
              textAlign: 'left'
            }}>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ 100 minučių per mėnesį</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ 3 kalbos (LT/EN/RU)</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ Ataskaitos</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ El. pašto palaikymas</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ Standartinis AI modelis</li>
            </ul>
            <a href="/registracija?plan=bazinis"
               className="btn-secondary"
               style={{ width: '100%', padding: '14px', fontSize: '1rem', textDecoration: 'none', display: 'block', borderRadius: '6px' }}>
              PASIRINKTI PLANĄ
            </a>
          </div>

          {/* Professional Plan - Featured */}
          <div style={{
            background: 'white',
            border: '3px solid #000042',
            borderRadius: '8px',
            padding: '2.5rem',
            textAlign: 'center',
            position: 'relative',
            transform: 'scale(1.05)',
            boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
          }}>
            <div style={{
              position: 'absolute',
              top: '-15px',
              left: '50%',
              transform: 'translateX(-50%)',
              background: '#000042',
              color: 'white',
              padding: '8px 20px',
              borderRadius: '20px',
              fontSize: '0.9rem',
              fontWeight: '600'
            }}>
              POPULIARIAUSIAS
            </div>
            <h3 style={{
              fontFamily: 'Georgia, serif',
              color: '#000042',
              fontSize: '1.8rem',
              marginBottom: '1rem'
            }}>
              Profesionalus
            </h3>
            <div style={{ marginBottom: '1rem' }}>
              <span style={{
                fontSize: '3rem',
                fontWeight: 'bold',
                color: '#000042',
                fontFamily: 'Georgia, serif'
              }}>€79</span>
              <span style={{ color: '#666', fontSize: '1rem' }}>/mėn</span>
            </div>
            <p style={{ color: '#666', marginBottom: '2rem' }}>
              Augančiam verslui
            </p>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              marginBottom: '2rem',
              textAlign: 'left'
            }}>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ 300 minučių per mėnesį</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ 3 kalbos (LT/EN/RU)</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ Ataskaitos</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ 24/7 palaikymas</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ Pažangus AI modelis</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ Individualizuotas mokymas</li>
            </ul>
            <a href="/registracija?plan=profesionalus"
               className="btn-cta"
               style={{ width: '100%', padding: '14px', fontSize: '1rem', textDecoration: 'none', display: 'block', borderRadius: '6px' }}>
              PASIRINKTI PLANĄ
            </a>
          </div>

          {/* Enterprise Plan */}
          <div style={{
            background: 'white',
            border: '2px solid #e9ecef',
            borderRadius: '8px',
            padding: '2.5rem',
            textAlign: 'center',
            position: 'relative',
            transition: 'all 0.3s ease'
          }}>
            <h3 style={{
              fontFamily: 'Georgia, serif',
              color: '#000042',
              fontSize: '1.8rem',
              marginBottom: '1rem'
            }}>
              Įmonės
            </h3>
            <div style={{ marginBottom: '1rem' }}>
              <span style={{
                fontSize: '3rem',
                fontWeight: 'bold',
                color: '#000042',
                fontFamily: 'Georgia, serif'
              }}>€199</span>
              <span style={{ color: '#666', fontSize: '1rem' }}>/mėn</span>
            </div>
            <p style={{ color: '#666', marginBottom: '2rem' }}>
              Didelėms įmonėms
            </p>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              marginBottom: '2rem',
              textAlign: 'left'
            }}>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ 500 minučių per mėnesį</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ 3 kalbos (LT/EN/RU)</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ Ataskaitos</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ Kelių vartotojų prieiga</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ API integracijos</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ Individualus palaikymas</li>
              <li style={{ padding: '0.5rem 0', color: '#555' }}>✓ Duomenų eksportavimas</li>
            </ul>
            <a href="/registracija?plan=imones"
               className="btn-secondary"
               style={{ width: '100%', padding: '14px', fontSize: '1rem', textDecoration: 'none', display: 'block', borderRadius: '6px' }}>
              PASIRINKTI PLANĄ
            </a>
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div style={{ marginTop: '4rem', textAlign: 'center' }}>
          <h2 style={{
            fontFamily: 'Georgia, serif',
            color: '#000042',
            fontSize: '2.5rem',
            marginBottom: '2rem'
          }}>
            Kodėl pasirinkti mus?
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '2rem',
            maxWidth: '900px',
            margin: '0 auto'
          }}>
            <div className="card" style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🚀</div>
              <h4 style={{ color: '#000042', marginBottom: '1rem' }}>Greitas paleidimas</h4>
              <p style={{ color: '#666' }}>Jūsų AI asistentas bus paruoštas per 24 val.</p>
            </div>
            <div className="card" style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔧</div>
              <h4 style={{ color: '#000042', marginBottom: '1rem' }}>Lengva konfigūracija</h4>
              <p style={{ color: '#666' }}>Intuityvus nustatymų valdymas be techninių žinių.</p>
            </div>
            <div className="card" style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🎯</div>
              <h4 style={{ color: '#000042', marginBottom: '1rem' }}>Pritaikytas jūsų sričiai</h4>
              <p style={{ color: '#666' }}>Specializuotas kiekvienai profesijai ir sričiai.</p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="card" style={{
          background: 'white',
          color: '#333',
          padding: '3rem',
          textAlign: 'center',
          borderRadius: '8px',
          border: '2px solid #e0e0e0',
          marginTop: '4rem'
        }}>
          <h2 style={{
            color: '#1a1a1a',
            fontFamily: 'var(--font-serif)',
            marginBottom: '1rem'
          }}>
            🚀 Pasiruošę pradėti?
          </h2>
          <p style={{
            marginBottom: '2rem',
            fontSize: '1.1rem',
            color: '#666'
          }}>
            Susisiekite su mumis jau šiandien ir sužinokite, kaip AI asistentas gali padėti jūsų verslui
          </p>
          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <a
              href="mailto:asistentas@gmail.com"
              className="btn-cta"
              style={{
                background: 'linear-gradient(135deg, var(--cta-primary), var(--cta-primary-hover))',
                border: 'none',
                color: 'white',
                padding: '0.75rem 2rem',
                textDecoration: 'none',
                borderRadius: '6px'
              }}
            >
              📧 Rašyti laišką
            </a>
            <a
              href="tel:+37063337939"
              className="btn-outline"
              style={{
                borderColor: '#1976d2',
                color: '#1976d2',
                background: 'transparent',
                padding: '0.75rem 2rem',
                border: '2px solid #1976d2',
                textDecoration: 'none',
                borderRadius: '6px'
              }}
            >
              📱 Skambinti dabar
            </a>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);

const Pagalba: React.FC = () => (
  <Layout showDemo={true}>
    <div className="container" style={{ marginTop: '120px', minHeight: 'calc(100vh - 300px)' }}>
      <div className="card" style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem' }}>
        <h1 style={{ fontFamily: 'Georgia, serif', color: '#000042', marginBottom: '1.5rem' }}>Pagalba ir DUK</h1>

        <div className="help-section" style={{ color: '#666', lineHeight: '1.7' }}>
      <h2>Dažnai užduodami klausimai</h2>

      <div style={{ marginBottom: '2rem' }}>
        <h3>❓ Kaip veikia AI asistentas?</h3>
        <p>Mūsų AI asistentas naudoja pažangiausias lietuvių kalbos technologijas, kad natūraliai bendrautų su jūsų klientais telefonu. Jis gali priimti užsakymus, atsakyti į klausimus ir perduoti svarbią informaciją jums.</p>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>📞 Ar klientai supras, kad kalba su AI?</h3>
        <p>Mūsų AI asistentas skamba labai natūraliai ir daugelis klientų neatpažįsta, kad kalba su kompiuteriu. Tačiau jei reikia, AI gali pristatyti save kaip asistentas.</p>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>⚡ Kaip greitai galiu pradėti naudoti?</h3>
        <p>Po registracijos jūsų AI asistentas bus paruoštas per 24 val. Mes padėsime sukonfigūruoti visus nustatymus pagal jūsų veiklos poreikius.</p>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>💰 Ar yra paslėpti mokesčiai?</h3>
        <p>Ne! Visos kainos nurodytos aiškiai. Mokate tik už pasirinktą mėnesinį planą. Jokių papildomų mokesčių už sąranką ar techninį palaikymą.</p>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>🔒 Ar mano duomenys saugūs?</h3>
        <p>Taip! Visi pokalbiai šifruojami, o duomenys saugomi pagal GDPR reikalavimus. Jūsų klientų informacija niekada nebus perduota tretiesiems asmenims.</p>
      </div>

      <h2>Reikia daugiau pagalbos?</h2>
      <div style={{ marginTop: '1.5rem', padding: '1.5rem', background: '#f0f8ff', borderRadius: '8px', border: '1px solid #b6d7ff', textAlign: 'center' }}>
        <p style={{ marginBottom: '1rem' }}>Mūsų specialistai pasiruošę padėti!</p>
        <a href="/kontaktai" style={{
          display: 'inline-block',
          padding: '0.75rem 1.5rem',
          background: '#1976d2',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '6px',
          fontWeight: '600',
          transition: 'all 0.3s ease'
        }} onMouseOver={(e) => (e.target as HTMLElement).style.background = '#1565c0'} onMouseOut={(e) => (e.target as HTMLElement).style.background = '#1976d2'}>
          Susisiekti su mumis
        </a>
      </div>
        </div>
      </div>
    </div>
  </Layout>
);

const Kontaktai: React.FC = () => (
  <Layout>
    {/* Hero Section */}
    <section style={{
      marginTop: '120px',
      padding: '4rem 0',
      background: 'linear-gradient(135deg, var(--neutral-light) 0%, var(--neutral-border) 100%)',
      minHeight: 'calc(100vh - 300px)'
    }}>
      <div className="container">
        <div className="section-header" style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 className="section-title" style={{
            color: 'var(--primary-navy)',
            fontFamily: 'var(--font-serif)',
            fontSize: '2.5rem',
            marginBottom: '1rem'
          }}>
            📞 Susisiekite su Mumis
          </h1>
          <p className="section-subtitle" style={{
            color: 'var(--secondary-gray)',
            fontSize: '1.2rem',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            Turite klausimų? Reikia pagalbos? Mūsų komanda pasiruošusi padėti jums bet kuriuo metu.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '2rem',
          marginBottom: '3rem'
        }}>
          {/* Contact Methods Card */}
          <div className="card" style={{
            background: 'white',
            borderRadius: '8px',
            padding: '2rem',
            border: '1px solid var(--neutral-border)',
            boxShadow: 'var(--shadow-sm)'
          }}>
            <h2 style={{
              color: 'var(--primary-navy)',
              fontFamily: 'var(--font-serif)',
              marginBottom: '2rem'
            }}>
              Kontaktinė informacija
            </h2>

            <div style={{ marginBottom: '2rem' }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                marginBottom: '1.5rem',
                padding: '1rem',
                background: 'var(--neutral-light)',
                borderRadius: '8px',
                border: '1px solid var(--neutral-border)'
              }}>
                <div style={{ fontSize: '1.5rem', minWidth: '2rem', color: 'var(--primary-navy)' }}>📧</div>
                <div>
                  <h3 style={{
                    color: 'var(--primary-navy)',
                    fontSize: '1.1rem',
                    margin: '0 0 0.25rem 0'
                  }}>
                    El. pašto adresas
                  </h3>
                  <p style={{ margin: '0', fontSize: '1rem' }}>
                    <a href="mailto:asistentas@gmail.com" style={{
                      color: 'var(--primary-navy-light)',
                      fontWeight: '600',
                      textDecoration: 'none'
                    }}>
                      asistentas@gmail.com
                    </a>
                  </p>
                  <p style={{
                    margin: '0.25rem 0 0 0',
                    color: 'var(--secondary-gray)',
                    fontSize: '0.9rem'
                  }}>
                    Atsakysime per 24 val.
                  </p>
                </div>
              </div>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                marginBottom: '1.5rem',
                padding: '1rem',
                background: 'var(--neutral-light)',
                borderRadius: '8px',
                border: '1px solid var(--neutral-border)'
              }}>
                <div style={{ fontSize: '1.5rem', minWidth: '2rem', color: 'var(--primary-navy)' }}>📱</div>
                <div>
                  <h3 style={{
                    color: 'var(--primary-navy)',
                    fontSize: '1.1rem',
                    margin: '0 0 0.25rem 0'
                  }}>
                    Telefonas
                  </h3>
                  <p style={{ margin: '0', fontSize: '1rem' }}>
                    <a href="tel:+37063337939" style={{
                      color: 'var(--primary-navy-light)',
                      fontWeight: '600',
                      textDecoration: 'none'
                    }}>
                      +370 633 37939
                    </a>
                  </p>
                  <p style={{
                    margin: '0.25rem 0 0 0',
                    color: 'var(--secondary-gray)',
                    fontSize: '0.9rem'
                  }}>
                    Darbo dienomis 9:00-18:00
                  </p>
                </div>
              </div>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                marginBottom: '1.5rem',
                padding: '1rem',
                background: 'var(--neutral-light)',
                borderRadius: '8px',
                border: '1px solid var(--neutral-border)'
              }}>
                <div style={{ fontSize: '1.5rem', minWidth: '2rem', color: 'var(--primary-navy)' }}>🏢</div>
                <div>
                  <h3 style={{
                    color: 'var(--primary-navy)',
                    fontSize: '1.1rem',
                    margin: '0 0 0.25rem 0'
                  }}>
                    Adresas
                  </h3>
                  <p style={{ margin: '0', fontSize: '1rem', color: 'var(--neutral-text)' }}>
                    A. Smetonos g. 3-32
                  </p>
                  <p style={{ margin: '0', fontSize: '1rem', color: 'var(--neutral-text)' }}>
                    Vilnius, Lietuva 01115
                  </p>
                </div>
              </div>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                padding: '1rem',
                background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                borderRadius: '8px',
                border: '1px solid #b6d7ff'
              }}>
                <div style={{ fontSize: '1.5rem', minWidth: '2rem', color: 'var(--primary-navy)' }}>⏰</div>
                <div>
                  <h3 style={{
                    color: 'var(--primary-navy)',
                    fontSize: '1.1rem',
                    margin: '0 0 0.25rem 0'
                  }}>
                    Darbo laikas
                  </h3>
                  <div style={{ fontSize: '0.95rem', color: 'var(--neutral-text)' }}>
                    <p style={{ margin: '0' }}><strong>Pr-Pt:</strong> 9:00-18:00</p>
                    <p style={{ margin: '0' }}><strong>Št-Sk:</strong> Išvykos ir konsultacijos</p>
                    <p style={{
                      margin: '0',
                      color: 'var(--primary-navy)',
                      fontWeight: '600'
                    }}>
                      <strong>AI asistentas:</strong> 24/7
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Features Card */}
          <div className="card" style={{
            background: 'white',
            borderRadius: '8px',
            padding: '2rem',
            border: '1px solid var(--neutral-border)',
            boxShadow: 'var(--shadow-sm)'
          }}>
            <h2 style={{
              color: 'var(--primary-navy)',
              fontFamily: 'var(--font-serif)',
              marginBottom: '2rem'
            }}>
              Kodėl rinktis mus?
            </h2>

            <div style={{ marginBottom: '1.5rem' }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '1rem',
                gap: '0.75rem'
              }}>
                <div style={{ fontSize: '1.25rem', minWidth: '1.5rem', textAlign: 'center' }}>⚡</div>
                <div style={{ flex: '1' }}>
                  <h4 style={{
                    margin: '0 0 0.25rem 0',
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: 'var(--primary-navy)'
                  }}>
                    Greitas atsakymas
                  </h4>
                  <p style={{
                    margin: '0',
                    fontSize: '0.9rem',
                    color: 'var(--secondary-gray)',
                    lineHeight: '1.3'
                  }}>
                    Atsakome per 24 valandas
                  </p>
                </div>
              </div>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '1rem',
                gap: '0.75rem'
              }}>
                <div style={{ fontSize: '1.25rem', minWidth: '1.5rem', textAlign: 'center' }}>🤝</div>
                <div style={{ flex: '1' }}>
                  <h4 style={{
                    margin: '0 0 0.25rem 0',
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: 'var(--primary-navy)'
                  }}>
                    Konsultacija
                  </h4>
                  <p style={{
                    margin: '0',
                    fontSize: '0.9rem',
                    color: 'var(--secondary-gray)',
                    lineHeight: '1.3'
                  }}>
                    Profesionalus aptarnavimas nuo pirmo skambučio
                  </p>
                </div>
              </div>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '1rem',
                gap: '0.75rem'
              }}>
                <div style={{ fontSize: '1.25rem', minWidth: '1.5rem', textAlign: 'center' }}>🌍</div>
                <div style={{ flex: '1' }}>
                  <h4 style={{
                    margin: '0 0 0.25rem 0',
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: 'var(--primary-navy)'
                  }}>
                    Lietuvių kalba
                  </h4>
                  <p style={{
                    margin: '0',
                    fontSize: '0.9rem',
                    color: 'var(--secondary-gray)',
                    lineHeight: '1.3'
                  }}>
                    Bendraujame lietuviškai
                  </p>
                </div>
              </div>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem'
              }}>
                <div style={{ fontSize: '1.25rem', minWidth: '1.5rem', textAlign: 'center' }}>🔒</div>
                <div style={{ flex: '1' }}>
                  <h4 style={{
                    margin: '0 0 0.25rem 0',
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: 'var(--primary-navy)'
                  }}>
                    Saugumas
                  </h4>
                  <p style={{
                    margin: '0',
                    fontSize: '0.9rem',
                    color: 'var(--secondary-gray)',
                    lineHeight: '1.3'
                  }}>
                    GDPR atitikimas ir duomenų apsauga
                  </p>
                </div>
              </div>
            </div>

            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <a
                href="mailto:asistentas@gmail.com"
                className="btn-cta"
                style={{
                  background: 'linear-gradient(135deg, var(--cta-primary), var(--cta-primary-hover))',
                  color: 'white',
                  padding: '0.75rem 2rem',
                  borderRadius: '6px',
                  textDecoration: 'none',
                  fontWeight: '600',
                  display: 'inline-block',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(255, 107, 53, 0.3)'
                }}
              >
                📧 Rašyti el. laišką
              </a>
            </div>
          </div>
        </div>

        {/* Legal Information Card */}
        <div className="card" style={{
          background: 'white',
          borderRadius: '8px',
          padding: '2rem',
          border: '1px solid var(--neutral-border)',
          boxShadow: 'var(--shadow-sm)',
          marginTop: '2rem'
        }}>
          <h2 style={{
            color: 'var(--primary-navy)',
            fontFamily: 'var(--font-serif)',
            marginBottom: '2rem'
          }}>
            Teisinė informacija
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem'
          }}>
            <div>
              <h3 style={{
                color: 'var(--primary-navy)',
                fontSize: '1.1rem',
                margin: '0 0 1rem 0'
              }}>
                Veiklą vykdo:
              </h3>
              <p style={{ margin: '0 0 0.5rem 0', color: 'var(--neutral-text)' }}>
                <strong>Justas Butkus</strong>
              </p>
              <p style={{ margin: '0 0 0.5rem 0', color: 'var(--neutral-text)' }}>
                Individualios veiklos pažyma Nr.: 1443626
              </p>
              <p style={{ margin: '0', color: 'var(--neutral-text)' }}>
                A. Smetonos g. 3-32, Vilnius, Lietuva 01115
              </p>
            </div>

            <div>
              <h3 style={{
                color: 'var(--primary-navy)',
                fontSize: '1.1rem',
                margin: '0 0 1rem 0'
              }}>
                Paslaugų politika:
              </h3>
              <ul style={{
                margin: '0',
                paddingLeft: '1.5rem',
                listStyle: 'none'
              }}>
                <li style={{ margin: '0 0 0.75rem 0' }}>
                  <a href="https://atsiliepsiu.lt/privatumo-politika" style={{
                    color: 'var(--primary-navy-light)',
                    textDecoration: 'none',
                    fontWeight: '500',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    <span>🔒</span> Privatumo politika
                  </a>
                </li>
                <li style={{ margin: '0' }}>
                  <a href="https://atsiliepsiu.lt/naudojimo-salygos" style={{
                    color: 'var(--primary-navy-light)',
                    textDecoration: 'none',
                    fontWeight: '500',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    <span>📋</span> Naudojimo sąlygos
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="card" style={{
          background: 'white',
          color: '#333',
          padding: '3rem',
          textAlign: 'center',
          borderRadius: '8px',
          border: '2px solid #e0e0e0'
        }}>
          <h2 style={{
            color: '#1a1a1a',
            fontFamily: 'var(--font-serif)',
            marginBottom: '1rem'
          }}>
            🚀 Pasiruošę pradėti?
          </h2>
          <p style={{
            marginBottom: '2rem',
            fontSize: '1.1rem',
            color: '#666'
          }}>
            Susisiekite su mumis jau šiandien ir sužinokite, kaip AI asistentas gali padėti jūsų verslui
          </p>
          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <a
              href="mailto:asistentas@gmail.com"
              className="btn-cta"
              style={{
                background: 'linear-gradient(135deg, var(--cta-primary), var(--cta-primary-hover))',
                border: 'none',
                color: 'white',
                padding: '0.75rem 2rem'
              }}
            >
              📧 Rašyti laišką
            </a>
            <a
              href="tel:+37063337939"
              className="btn-outline"
              style={{
                borderColor: '#1976d2',
                color: '#1976d2',
                background: 'transparent',
                padding: '0.75rem 2rem',
                border: '2px solid #1976d2'
              }}
            >
              📱 Skambinti dabar
            </a>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);

const NaudojimosiSalygos: React.FC = () => (
  <Layout>
    <div className="container" style={{
      paddingTop: '120px',
      paddingBottom: '80px',
      background: 'white',
      minHeight: '100vh'
    }}>
      <div className="card" style={{
        maxWidth: '900px',
        margin: '0 auto',
        padding: '3rem',
        boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
      }}>
        <div className="section-header text-center" style={{ marginBottom: '3rem' }}>
          <h1 className="section-title lithuanian-heading" style={{
            color: '#000042',
            fontSize: '2.5rem',
            marginBottom: '1rem'
          }}>
            📋 Naudojimosi sąlygos
          </h1>
          <p style={{ color: '#666', fontSize: '1.1rem' }}>
            <em>Paskutinį kartą atnaujinta: 2025 m. sausio 1 d.</em>
          </p>
        </div>

        <div className="terms-content" style={{
          color: '#333',
          lineHeight: '1.7',
          fontSize: '1rem'
        }}>
          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>1. Bendrosios nuostatos</h2>
      <p>Šios naudojimosi sąlygos (toliau – Sąlygos) reglamentuoja AI balso asistentas paslaugų naudojimą svetainėje <strong>www.meistroasistentas.lt</strong>.</p>

      <p><strong>Paslaugų teikėjas:</strong> Justas Butkus</p>
      <p><strong>Individualios veiklos pažyma Nr.:</strong> 1443626</p>
      <p><strong>El. pašto adresas:</strong> asistentas@gmail.com</p>
      <p><strong>Telefonas:</strong> +370 633 37939</p>
      <p><strong>Adresas:</strong> A. Smetonos g. 3-32, Vilnius, Lietuva 01115</p>

      <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>2. Terminų apibrėžimai</h2>
      <ul>
        <li><strong>Paslaugos</strong> – AI balso asistentas paslaugos, teikiamos per meistroasistentas.lt platformą</li>
        <li><strong>Vartotojas</strong> – fizinis asmuo, registruojantis ir naudojantis Paslaugas</li>
        <li><strong>AI asistentas</strong> – automatizuota sistema, priimanti telefono skambučius ir bendraujanti su klientais</li>
        <li><strong>Sutartis</strong> – šios Sąlygos kartu su registracijos duomenimis sudaro paslaugų teikimo sutartį</li>
      </ul>

      <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>3. Paslaugų aprašymas</h2>
      <p>Mes teikiame šias paslaugas:</p>
      <ul>
        <li>AI balso asistentas paslaugos telefonu</li>
        <li>Skambučių ataskaitos ir analizė</li>
        <li>Klientų užklausų perdavimas elektroniniu paštu</li>
        <li>Techninis palaikymas ir konsultacijos</li>
        <li>AI asistentas konfigūravimas pagal veiklos poreikius</li>
      </ul>

      <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>4. Registracija ir sutarties sudarymas</h2>
      <p>Sutartis laikoma sudaryta nuo momento, kai:</p>
      <ul>
        <li>Vartotojas pateikia registracijos formą</li>
        <li>Paslaugų teikėjas patvirtina registraciją elektroniniu paštu</li>
        <li>Vartotojas atlieka pirmąjį mokėjimą (jei reikalaujama)</li>
      </ul>

      <p>Registruotis gali tik pilnamečiai asmenys (nuo 18 metų) arba juridiniai asmenys per savo įgaliotus atstovus.</p>

      <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>5. Vartotojo teisės ir pareigos</h2>

      <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Vartotojo teisės:</h3>
      <ul>
        <li>Gauti kokybiškas Paslaugas pagal sutartą planą</li>
        <li>Reikalauti Paslaugų konfigūravimo pagal savo poreikius</li>
        <li>Gauti techninį palaikymą</li>
        <li>Nutraukti sutartį bet kuriuo metu</li>
        <li>Gauti ataskaitas apie AI asistento veiklą</li>
      </ul>

      <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Vartotojo pareigos:</h3>
      <ul>
        <li>Laiku mokėti už Paslaugas</li>
        <li>Pateikti tikrus ir teisingus registracijos duomenis</li>
        <li>Nedelsdamas informuoti apie duomenų pakeitimus</li>
        <li>Nenaudoti Paslaugų neteisėtiems tikslams</li>
        <li>Netrikdyti kitų Vartotojų ar Paslaugų teikėjo veiklos</li>
        <li>Laikytis šių Sąlygų</li>
      </ul>

      <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>6. Mokėjimo sąlygos</h2>
      <ul>
        <li><strong>Mokėjimo periodiškumas:</strong> Mėnesinis mokėjimas iš anksto</li>
        <li><strong>Mokėjimo būdai:</strong> Banko pavedimu arba mokėjimo kortelėmis</li>
        <li><strong>Mokėjimo terminas:</strong> Iki kito mokėjimo periodo pradžios</li>
        <li><strong>Vėlavimo palūkanos:</strong> 0,05% per dieną nuo vėluojamos sumos</li>
        <li><strong>Sąskaitos:</strong> Siunčiamos el. paštu iki mėnesio pabaigos</li>
      </ul>

      <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>7. Paslaugų teikimo sąlygos</h2>
      <ul>
        <li><strong>Paslaugų prieinamumas:</strong> 99,5% per mėnesį (be techninės profilaktikos laiko)</li>
        <li><strong>Techninis palaikymas:</strong> Darbo dienomis 9:00-18:00</li>
        <li><strong>Avarinė pagalba:</strong> 24/7 (kritinių gedimų atveju)</li>
        <li><strong>Atsakymo laikas:</strong> Iki 4 darbo valandų</li>
      </ul>

      <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>8. Atsakomybės apribojimas</h2>
      <p>Paslaugų teikėjas neatsako už:</p>
      <ul>
        <li>Nuostolius, kilusius dėl interneto ryšio sutrikimų</li>
        <li>Netiesioginius ar atsitiktinius nuostolius</li>
        <li>Vartotojo duomenų praradimą dėl techninių gedimų</li>
        <li>AI asistento neteisingus atsakymus, jei jie atitinka pateiktą informaciją</li>
        <li>Trečiųjų asmenų veiksmus</li>
      </ul>

      <p>Maksimalus atsakomybės dydis neviršija trijų mėnesinių mokesčių sumos.</p>

      <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>9. Intelektinės nuosavybės teisės</h2>
      <ul>
        <li>Visos teisės į AI asistento technologiją priklauso Paslaugų teikėjui</li>
        <li>Vartotojas gauna tik naudojimosi teisę paslaugų teikimo laikotarpiui</li>
        <li>Draudžiama kopijuoti, platinti ar kitaip naudoti technologiją be leidimo</li>
        <li>Pokalbių turinys priklauso Vartotojui, bet gali būti naudojamas AI tobulinimui</li>
      </ul>

      <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>10. Duomenų apsauga</h2>
      <p>Duomenų tvarkymas vykdomas pagal <a href="/privatumo-politika">Privatumo politiką</a>. Pagrindiniai principai:</p>
      <ul>
        <li>Duomenų šifravimas perdavimo ir saugojimo metu</li>
        <li>Prieigos kontrolė ir auditavimas</li>
        <li>GDPR reikalavimų laikymasis</li>
        <li>Duomenų saugojimo terminų laikymasis</li>
      </ul>

      <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>11. Force Majeure</h2>
      <p>Šalys atleidžiamos nuo atsakomybės už įsipareigojimų nevykdymą, jei jis kilo dėl nenugalimos jėgos aplinkybių:</p>
      <ul>
        <li>Stichinės nelaimės</li>
        <li>Karo veiksmai, terorizmas</li>
        <li>Vyriausybės sprendimai</li>
        <li>Masiniai interneto sutrikdymai</li>
        <li>Kibernetinės atakos</li>
      </ul>

      <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>12. Sutarties pakeitimai ir nutraukimas</h2>

      <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Sąlygų keitimas:</h3>
      <ul>
        <li>Paslaugų teikėjas gali keisti Sąlygas pranešdamas 30 dienų iš anksto</li>
        <li>Apie pokyčius informuojama el. paštu ir svetainėje</li>
        <li>Toliau naudojant Paslaugas laikoma, kad sutinkama su naujomis Sąlygomis</li>
      </ul>

      <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Sutarties nutraukimas:</h3>
      <ul>
        <li><strong>Vartotojas:</strong> Gali nutraukti bet kuriuo metu pranešdamas 7 dienas iš anksto</li>
        <li><strong>Paslaugų teikėjas:</strong> Gali nutraukti pažeidus Sąlygas arba nevykdant mokėjimo įsipareigojimų</li>
        <li><strong>Duomenų likimas:</strong> Išsaugomi 30 dienų po nutraukimo, tada ištrinami</li>
      </ul>

      <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>13. Ginčų sprendimas</h2>
      <ul>
        <li>Ginčai sprendžiami derybų keliu</li>
        <li>Jei derybos nesėkmingos – kreipiamasi į Vilniaus miesto apylinkės teismą</li>
        <li>Taikomas Lietuvos Respublikos teisės aktai</li>
        <li>Vartotojai gali kreiptis į Valstybinę vartotojų teisių apsaugos tarnybą</li>
      </ul>

      <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>14. Kontaktinė informacija</h2>
      <div style={{ marginTop: '1rem', padding: '1.5rem', background: '#f0f8ff', borderRadius: '8px', border: '1px solid #b6d7ff', textAlign: 'center' }}>
        <p style={{ marginBottom: '1rem' }}>Klausimų dėl šių sąlygų?</p>
        <a href="/kontaktai" style={{
          display: 'inline-block',
          padding: '0.75rem 1.5rem',
          background: '#1976d2',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '6px',
          fontWeight: '600',
          transition: 'all 0.3s ease'
        }} onMouseOver={(e) => (e.target as HTMLElement).style.background = '#1565c0'} onMouseOut={(e) => (e.target as HTMLElement).style.background = '#1976d2'}>
          Susisiekti su mumis
        </a>
      </div>

      <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>15. Baigiamosios nuostatos</h2>
      <ul>
        <li>Šios Sąlygos įsigalioja nuo 2025 m. sausio 1 d.</li>
        <li>Jei kuri nors Sąlygų dalis pripažįstama negaliojančia, kitos dalys išlieka galiojančios</li>
        <li>Šių Sąlygų pažeidimas gali būti pagrindas sutarties nutraukimui</li>
        <li>Visos Sąlygos turi būti aiškinama pagal Lietuvos Respublikos įstatymus</li>
      </ul>

      <div style={{ marginTop: '2rem', padding: '1.5rem', background: '#f0f8ff', borderRadius: '8px', border: '1px solid #b6d7ff', textAlign: 'center' }}>
        <p style={{ marginBottom: '1rem' }}><strong>📞 Klausimai dėl naudojimosi sąlygų?</strong></p>
        <a href="/kontaktai" style={{
          display: 'inline-block',
          padding: '0.75rem 1.5rem',
          background: '#1976d2',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '6px',
          fontWeight: '600',
          transition: 'all 0.3s ease'
        }} onMouseOver={(e) => (e.target as HTMLElement).style.background = '#1565c0'} onMouseOut={(e) => (e.target as HTMLElement).style.background = '#1976d2'}>
          Susisiekti su mumis
        </a>
        </div>
        </div>
      </div>
    </div>
  </Layout>
);

const PrivatumoPolitika: React.FC = () => (
  <Layout>
    <div className="container" style={{
      paddingTop: '120px',
      paddingBottom: '80px',
      background: 'white',
      minHeight: '100vh'
    }}>
      <div className="card" style={{
        maxWidth: '900px',
        margin: '0 auto',
        padding: '3rem',
        boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
      }}>
        <div className="section-header text-center" style={{ marginBottom: '3rem' }}>
          <h1 className="section-title lithuanian-heading" style={{
            color: '#000042',
            fontSize: '2.5rem',
            marginBottom: '1rem'
          }}>
            🔒 Privatumo politika
          </h1>
          <p style={{ color: '#666', fontSize: '1.1rem' }}>
            <em>Paskutinį kartą atnaujinta: 2025 m. sausio 28 d.</em>
          </p>
        </div>

        <div className="terms-content" style={{
          color: '#333',
          lineHeight: '1.7',
          fontSize: '1rem'
        }}>
          <h2 style={{ fontFamily: 'Georgia, serif', color: '#000042', marginTop: '2rem', marginBottom: '1rem', fontSize: '1.5rem' }}>1. Duomenų valdytojas</h2>

          <p><strong>Veiklą vykdo:</strong> Justas Butkus</p>
          <p><strong>Individualios veiklos pažyma Nr.:</strong> 1443626</p>
          <p><strong>El. paštas:</strong> asistentas@gmail.com</p>
          <p><strong>Telefonas:</strong> +370 633 37939</p>
          <p><strong>Svetainė:</strong> www.meistroasistentas.lt</p>
          <p><strong>Adresas:</strong> A. Smetonos g. 3-32, Vilnius, Lietuva 01115</p>

          <p>Mes, meistroasistentas.lt, vertiname Jūsų privatumą ir įsipareigojame saugoti Jūsų asmens duomenis. Ši privatumo politika paaiškina, kaip mes renkame, naudojame ir saugome Jūsų asmens duomenis, kai naudojatės mūsų AI balso asistento paslaugomis amatininkams ir verslo subjektams.</p>

          <p>Naudodamiesi mūsų paslaugomis, Jūs sutinkate su šioje politikoje aprašytomis sąlygomis.</p>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>2. Duomenų tvarkymo principai</h2>
          <p>Mes laikomės Bendrojo duomenų apsaugos reglamento (BDAR) reikalavimų ir tvarkome Jūsų duomenis vadovaudamiesi šiais principais:</p>
          <ul>
            <li>Teisėtumas, sąžiningumas ir skaidrumas</li>
            <li>Tikslo apribojimas</li>
            <li>Duomenų kiekio mažinimas</li>
            <li>Tikslumas</li>
            <li>Saugojimo trukmės apribojimas</li>
            <li>Vientisumo ir konfidencialumo užtikrinimas</li>
          </ul>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>3. Kokie duomenys renkami</h2>
          <p>Renkame tik tuos duomenis, kurie būtini paslaugų teikimui:</p>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Registracijos duomenys:</h3>
          <ul>
            <li>Vardas, pavardė</li>
            <li>El. pašto adresas</li>
            <li>Telefono numeris</li>
            <li>Profesijos tipas (dažytojas, stalius, santechnikas, elektrikas, stogdengys)</li>
            <li>Darbo patirtis metais</li>
            <li>Darbo regionas</li>
            <li>Paslaugų kainos</li>
            <li>Darbo valandos</li>
            <li>Papildoma verslo informacija</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Pokalbių duomenys:</h3>
          <ul>
            <li>AI asistento pokalbių transkriptai su klientais</li>
            <li>Pokalbių įrašai (balso duomenys)</li>
            <li>Klientų užklausų kategorijos ir santraukos</li>
            <li>Skambučių trukmė ir laikas</li>
            <li>Klientų kontaktinė informacija (jei pateikta pokalbio metu)</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Techniniai duomenys:</h3>
          <ul>
            <li>IP adresas</li>
            <li>Naršyklės tipas ir versija</li>
            <li>Operacinė sistema</li>
            <li>Prisijungimo data ir laikas</li>
            <li>Seanso duomenys</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Slapukų duomenys:</h3>
          <ul>
            <li>Sesijos identifikatoriai</li>
            <li>Autentifikacijos žetonai</li>
            <li>Analitikos duomenys</li>
            <li>Funkcionalumo nustatymai</li>
          </ul>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>4. Duomenų šaltiniai</h2>
          <p>Visus asmens duomenis renkame tiesiogiai iš Jūsų:</p>
          <ul>
            <li>Kai registruojatės mūsų paslaugai per registracijos formą</li>
            <li>Kai AI asistentas priima skambučius Jūsų vardu</li>
            <li>Kai naudojatės mūsų svetaine ir valdymo skydeliu</li>
            <li>Kai susisiekiate su mumis el. paštu ar telefonu</li>
            <li>Per automatizuotus duomenų rinkimo įrankius (slapukai, analitika)</li>
          </ul>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>5. Duomenų tvarkymo tikslai ir teisiniai pagrindai</h2>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '1.5rem' }}>
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  <th style={{ border: '1px solid #ddd', padding: '0.8rem', textAlign: 'left' }}>Tikslai</th>
                  <th style={{ border: '1px solid #ddd', padding: '0.8rem', textAlign: 'left' }}>Teisiniai pagrindai</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '0.8rem' }}>AI asistento paslaugų teikimas ir konfigūravimas</td>
                  <td style={{ border: '1px solid #ddd', padding: '0.8rem' }}>Sutarties vykdymas (BDAR 6 str. 1 d. b p.)</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '0.8rem' }}>Pokalbių ataskaitų generavimas ir siuntimas</td>
                  <td style={{ border: '1px solid #ddd', padding: '0.8rem' }}>Sutarties vykdymas (BDAR 6 str. 1 d. b p.)</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '0.8rem' }}>Klientų užklausų perdavimas el. paštu</td>
                  <td style={{ border: '1px solid #ddd', padding: '0.8rem' }}>Sutarties vykdymas (BDAR 6 str. 1 d. b p.)</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '0.8rem' }}>Paslaugų tobulinimas ir AI modelių optimizavimas</td>
                  <td style={{ border: '1px solid #ddd', padding: '0.8rem' }}>Teisėti interesai (BDAR 6 str. 1 d. f p.)</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '0.8rem' }}>Mokėjimų duomenų saugojimas (5 metai)</td>
                  <td style={{ border: '1px solid #ddd', padding: '0.8rem' }}>Teisinės prievolės vykdymas (BDAR 6 str. 1 d. c p.)</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '0.8rem' }}>Slapukų naudojimas analitikai ir funkcionalumui</td>
                  <td style={{ border: '1px solid #ddd', padding: '0.8rem' }}>Jūsų sutikimas (BDAR 6 str. 1 d. a p.)</td>
                </tr>
                <tr>
                  <td style={{ border: '1px solid #ddd', padding: '0.8rem' }}>Kliento aptarnavimas ir techninis palaikymas</td>
                  <td style={{ border: '1px solid #ddd', padding: '0.8rem' }}>Teisėti interesai (BDAR 6 str. 1 d. f p.)</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>6. Automatizuotas sprendimų priėmimas ir profiliavimas</h2>
          <p>Mūsų AI asistentas naudoja algoritmus ir profiliavimą šiems tikslams:</p>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Profiliavimo rūšys:</h3>
          <ul>
            <li><strong>Klientų užklausų kategorizavimas:</strong> AI analizuoja skambučius ir priskiria jiems kategorijas (konsultacija, skubus darbas, kainų užklausa ir kt.)</li>
            <li><strong>Automatinis atsakymų generavimas:</strong> Remiantis Jūsų verslo informacija, AI generuoja personalizuotus atsakymus klientams</li>
            <li><strong>Prioritetų nustatymas:</strong> Skambučiai rūšiuojami pagal skubumą ir svarbą</li>
            <li><strong>Veiklos analitika:</strong> Analizuojami pokalbių šablonai verslo veiklos optimizavimui</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Poveikis Jums:</h3>
          <ul>
            <li>Profiliavimas padeda AI geriau atstovauti Jūsų verslui</li>
            <li>Automatinis klientų skirstymas pagal užklausų tipus</li>
            <li>Personalizuoti atsakymai, atspindintys Jūsų darbo stilių ir kainas</li>
            <li>Nėra teisinių pasekmių ar reikšmingo poveikio Jūsų teisėms</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Jūsų teisės:</h3>
          <ul>
            <li>Teisė prašyti žmogaus įsikišimo į automatizuotus sprendimus</li>
            <li>Teisė pareikšti savo požiūrį ir ginčyti AI sprendimus</li>
            <li>Teisė atsisisakyti automatizuoto sprendimų priėmimo (gali apriboti paslaugų funkcionalumą)</li>
          </ul>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>7. Duomenų gavėjai</h2>
          <p>Jūsų duomenys gali būti perduodami šiems gavėjams:</p>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Technologijų partneriai:</h3>
          <ul>
            <li><strong>OpenAI (JAV)</strong> - AI pokalbių apdorojimui (tik anoniminiai transkriptai)</li>
            <li><strong>Telnyx</strong> - telefono skambučių valdymui ir maršrutizavimui</li>
            <li><strong>Google Cloud/Gmail</strong> - el. pašto paslaugoms ir duomenų saugojimui</li>
            <li><strong>DigitalOcean/Hetzner</strong> - serverių paslaugoms ir duomenų saugojimui</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Mokėjimų tvarkytojai:</h3>
          <ul>
            <li><strong>Stripe/PayPal</strong> - saugiems mokėjimams</li>
            <li><strong>Bankai ir mokėjimo sistemos</strong> - sąskaitų apmokėjimui</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Analitikos paslaugos:</h3>
          <ul>
            <li><strong>Google Analytics</strong> - svetainės naudojimo statistikai</li>
            <li><strong>Hotjar/Mixpanel</strong> - vartotojų elgsenos analizei (su sutikimu)</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Teisinės institucijos:</h3>
          <ul>
            <li>Kompetentingos valdžios institucijos (tik teisės aktų reikalavimų atveju)</li>
            <li>Teismai (teismo sprendimų vykdymui)</li>
          </ul>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>8. Tarptautinis duomenų perdavimas</h2>
          <p>Kai kurie mūsų paslaugų teikėjai yra įsikūrę už ES/EEE ribų:</p>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>OpenAI (JAV) - AI paslaugų teikėjas</h3>
          <ul>
            <li><strong>Apsaugos priemonės:</strong> Standartinės sutartinės sąlygos (SCC), duomenų apdorojimo sutartis</li>
            <li><strong>Perduodami duomenys:</strong> Tik anoniminiai pokalbių transkriptai be asmeninės informacijos</li>
            <li><strong>Duomenų naikinimas:</strong> Duomenys naikinami iš OpenAI sistemų per 30 dienų po apdorojimo</li>
            <li><strong>Saugumas:</strong> SOC 2 Type II sertifikatas, šifravimas rest ir transit režimais</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Google Cloud (JAV) - debesų paslaugos</h3>
          <ul>
            <li><strong>Apsaugos priemonės:</strong> Atitikimas GDPR, standartinės sutartinės sąlygos</li>
            <li><strong>Duomenų vieta:</strong> ES regionai, kai įmanoma</li>
            <li><strong>IP adresų anoniminizavimas:</strong> Įjungtas Google Analytics</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Telnyx (JAV) - telefonijos paslaugos</h3>
          <ul>
            <li><strong>Apsaugos priemonės:</strong> HIPAA atitikimas, duomenų apdorojimo sutartis</li>
            <li><strong>Perduodami duomenys:</strong> Telefono numeriai, skambučių metaduomenys</li>
            <li><strong>Saugumas:</strong> End-to-end šifravimas, SOC 2 sertifikavimas</li>
          </ul>

          <p>Visi duomenų perdavimai už ES/EEE ribų vykdomi laikantis BDAR reikalavimų ir taikant tinkamas apsaugos priemones.</p>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>9. Duomenų saugojimo terminai</h2>
          <ul>
            <li><strong>Registracijos duomenys:</strong> Iki sutarties nutraukimo + 6 mėnesiai</li>
            <li><strong>Pokalbių įrašai (audio):</strong> 30 dienų po pokalbio (automatinis trynimas)</li>
            <li><strong>Pokalbių transkriptai:</strong> 12 mėnesių (analitikos tikslais)</li>
            <li><strong>Pokalbių santraukos:</strong> 24 mėnesiai (verslo intelekto tikslais)</li>
            <li><strong>Techniniai logai:</strong> 90 dienų</li>
            <li><strong>Mokėjimų duomenys:</strong> 5 metai (pagal LR buhalterinės apskaitos įstatymą)</li>
            <li><strong>Slapukų duomenys:</strong> Iki 24 mėnesių arba iki sutikimo atšaukimo</li>
            <li><strong>El. pašto komunikacijos:</strong> 3 metai</li>
            <li><strong>Kliento aptarnavimo pokalbiai:</strong> 1 metai</li>
          </ul>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>10. Jūsų teisės</h2>
          <p>Pagal BDAR Jūs turite šias teises:</p>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Informacijos teisės:</h3>
          <ul>
            <li><strong>Teisė gauti informaciją</strong> apie duomenų tvarkymą (ši politika)</li>
            <li><strong>Teisė susipažinti</strong> su tvarkomais duomenimis (duomenų kopijos gavimas)</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Korekcijos teisės:</h3>
          <ul>
            <li><strong>Teisė ištaisyti</strong> netikslius ar neišsamius duomenis</li>
            <li><strong>Teisė papildyti</strong> trūkstamus duomenis</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Trynimo teisės:</h3>
          <ul>
            <li><strong>Teisė ištrinti duomenis</strong> ("teisė būti pamirštam")</li>
            <li><strong>Teisė apriboti tvarkymą</strong> tam tikrais atvejais</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Perkeliamų duomenų teisės:</h3>
          <ul>
            <li><strong>Teisė į duomenų perkeliamumą</strong> (gauti duomenis strukturuotame formate)</li>
            <li><strong>Teisė perduoti duomenis</strong> kitam valdytojui</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Nesutikimo teisės:</h3>
          <ul>
            <li><strong>Teisė nesutikti</strong> su duomenų tvarkymu (teisėtų interesų pagrindu)</li>
            <li><strong>Teisė atšaukti sutikimą</strong> bet kuriuo metu</li>
            <li><strong>Teisė nesutikti</strong> su automatizuotu sprendimų priėmimu</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Apsaugos teisės:</h3>
          <ul>
            <li><strong>Teisė pateikti skundą</strong> Valstybinei duomenų apsaugos inspekcijai</li>
            <li><strong>Teisė kreiptis į teismą</strong> dėl duomenų apsaugos pažeidimų</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Kaip pasinaudoti teisėmis:</h3>
          <p>Norėdami pasinaudoti savo teisėmis:</p>
          <ul>
            <li>Rašykite el. paštu: <strong>asistentas@gmail.com</strong></li>
            <li>Skambinkite: <strong>+370 633 37939</strong></li>
            <li>Nurodykite savo tapatybę ir konkretų prašymą</li>
            <li>Atsakysime per 1 mėnesį (sudėtingais atvejais - iki 3 mėnesių)</li>
          </ul>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>11. Slapukų politika</h2>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Slapukų tipai ir tikslai</h3>
          <p>Mes naudojame šiuos slapukus:</p>

          <h4>Būtini slapukai</h4>
          <ul>
            <li><strong>Paskirtis:</strong> Svetainės veikimui būtini funkcionalumai</li>
            <li><strong>Pavyzdžiai:</strong> Sesijos valdymas, autentifikacija, krepšelio turinys</li>
            <li><strong>Galiojimo laikas:</strong> Sesijos trukmė arba iki 1 metų</li>
            <li><strong>Teisinis pagrindas:</strong> Teisėti interesai (būtini paslaugai teikti)</li>
          </ul>

          <h4>Funkciniai slapukai</h4>
          <ul>
            <li><strong>Paskirtis:</strong> Naudotojo patirties pagerinimas</li>
            <li><strong>Pavyzdžiai:</strong> Kalbos nustatymai, išsaugoti formos duomenys</li>
            <li><strong>Galiojimo laikas:</strong> Iki 24 mėnesių</li>
            <li><strong>Teisinis pagrindas:</strong> Jūsų sutikimas</li>
          </ul>

          <h4>Analitiniai slapukai</h4>
          <ul>
            <li><strong>Paskirtis:</strong> Svetainės naudojimo statistika ir optimizavimas</li>
            <li><strong>Teikėjai:</strong> Google Analytics, Hotjar</li>
            <li><strong>Galiojimo laikas:</strong> Iki 24 mėnesių</li>
            <li><strong>Teisinis pagrindas:</strong> Jūsų sutikimas</li>
            <li><strong>Anoniminizacija:</strong> IP adresai anoniminizuojami</li>
          </ul>

          <h4>Rinkodaros slapukai</h4>
          <ul>
            <li><strong>Paskirtis:</strong> Personalizuota reklama ir retargeting</li>
            <li><strong>Teikėjai:</strong> Google Ads, Facebook Pixel</li>
            <li><strong>Galiojimo laikas:</strong> Iki 24 mėnesių</li>
            <li><strong>Teisinis pagrindas:</strong> Jūsų sutikimas</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Sutikimo valdymas</h3>
          <p>Pirmą kartą apsilankius svetainėje:</p>
          <ul>
            <li>Rodomas slapukų sutikimo pranešimas</li>
            <li>Galite pasirinkti: sutikti su visais, tik būtinais arba individualizuoti</li>
            <li>Jūsų pasirinkimai išsaugomi 12 mėnesių</li>
            <li>Sutikimą galite bet kada pakeisti svetainės apačioje esančiame "Slapukų nustatymai" skyriuje</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Trečiųjų šalių slapukai</h3>
          <ul>
            <li><strong>Google Analytics:</strong> _ga, _ga_*, _gid</li>
            <li><strong>Google Ads:</strong> _gcl_au, _gac_*</li>
            <li><strong>Facebook:</strong> _fbp, _fbc</li>
            <li><strong>Hotjar:</strong> _hjSessionUser_*, _hjSession_*</li>
          </ul>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>12. Duomenų saugumas</h2>
          <p>Taikome išsamias technines ir organizacines priemones:</p>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Techninės priemonės:</h3>
          <ul>
            <li><strong>Šifravimas:</strong> AES-256 duomenų saugykloje, TLS 1.3 perdavimui</li>
            <li><strong>Prieigos kontrolė:</strong> Daugiafaktorių autentifikacija (MFA), vaidmenų sistema</li>
            <li><strong>Tinklų saugumas:</strong> Firewalls, DDoS apsauga, VPN prieiga</li>
            <li><strong>Monitoringas:</strong> 24/7 saugumo stebėjimas, anomalijų aptikimas</li>
            <li><strong>Atsarginės kopijos:</strong> Automatinės kasdienės kopijos, geografiškai paskirstytos</li>
            <li><strong>Penetracijos testai:</strong> Ketvirčio saugumo vertinimai</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Organizacinės priemonės:</h3>
          <ul>
            <li><strong>Darbuotojų mokymai:</strong> GDPR ir kibernetinio saugumo mokymai</li>
            <li><strong>Prieigos apribojimai:</strong> Minimaliųjų privilegijų principas</li>
            <li><strong>Sutartys:</strong> Konfidencialumo susitarimai su visais darbuotojais</li>
            <li><strong>Incidentų valdymas:</strong> 72 valandų pranešimo procedūros</li>
            <li><strong>Duomenų klasifikacija:</strong> Jautrumo lygių sistema</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Saugumo sertifikatai:</h3>
          <ul>
            <li>SOC 2 Type II (planuojamas 2025 Q2)</li>
            <li>ISO 27001 atitikimas (planuojamas 2025 Q4)</li>
            <li>GDPR atitikimo sertifikavimas</li>
          </ul>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>13. Duomenų pažeidimų valdymas</h2>
          <p>Duomenų pažeidimo atveju mes:</p>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Vidinis reagavimas (0-24 val.):</h3>
          <ul>
            <li>Nedelsiant stabdome pažeidimą ir įvertiname mastą</li>
            <li>Dokumentuojame incidentą ir priežastis</li>
            <li>Įvertiname riziką duomenų subjektams</li>
            <li>Formuojame atkūrimo planą</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Pranešimas reguliatoriams (72 val.):</h3>
          <ul>
            <li>Pranešame Valstybinei duomenų apsaugos inspekcijai</li>
            <li>Pateikiame išsamų incidento aprašymą</li>
            <li>Nurodome paveiktą duomenų kategoriją ir subjektų skaičių</li>
            <li>Aprašome imamų priemonių planą</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Pranešimas duomenų subjektams:</h3>
          <ul>
            <li>Nedelsiant informuojame, jei yra didelė rizika teisėms ir laisvėms</li>
            <li>Aiškiai aprašome pažeidimo pobūdį ir galimas pasekmes</li>
            <li>Nurodome imamas apsaugos priemones</li>
            <li>Pateikiame kontaktinę informaciją klausimams</li>
          </ul>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>14. Nepilnamečių duomenų apsauga</h2>
          <p>Mūsų paslaugos skirtos tik suaugusiems:</p>
          <ul>
            <li><strong>Amžiaus riba:</strong> Tik asmenims nuo 18 metų</li>
            <li><strong>Verifikacija:</strong> Registracijos metu prašome patvirtinti amžių</li>
            <li><strong>Atsitiktinis rinkimas:</strong> Jei netyčia surenkame nepilnamečio duomenis, ištriname per 48 val.</li>
            <li><strong>Tėvų teisės:</strong> Tėvai gali reikalauti ištrinti vaiko duomenis</li>
            <li><strong>Komercinė komunikacija:</strong> Nepilnamečiams nesiųsčiama</li>
          </ul>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>15. Privatumo politikos pakeitimai</h2>
          <p>Šią politiką galime atnaujinti:</p>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Smulkūs pakeitimai:</h3>
          <ul>
            <li>Informuojame svetainėje ir el. paštu</li>
            <li>Galioja po 14 dienų nuo paskelbimo</li>
            <li>Toliau naudojant paslaugas = sutikimas</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Esminiai pakeitimai:</h3>
          <ul>
            <li>Prašome aiškaus sutikimo</li>
            <li>30 dienų apsvarstymo laikas</li>
            <li>Teisė nutraukti sutartį be sankcijų</li>
            <li>Išsamus pakeitimų paaiškinimas</li>
          </ul>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Versijų istorija:</h3>
          <ul>
            <li>v1.0 - 2025-01-01: Pradinė versija</li>
            <li>v1.1 - 2025-01-28: Išsamūs slapukų ir AI profiliavimo aprašymai</li>
          </ul>

          <h2 style={{ color: '#000042', fontSize: '1.5rem', marginTop: '2rem', marginBottom: '1rem', fontFamily: 'Georgia, serif' }}>16. Kontaktinė informacija</h2>

          <h3 style={{ color: '#000042', fontSize: '1.2rem', marginTop: '1.5rem', marginBottom: '0.8rem', fontFamily: 'Georgia, serif' }}>Duomenų apsaugos klausimais:</h3>
          <div style={{ padding: '1rem', background: '#f8f9fa', borderRadius: '8px', marginBottom: '1rem' }}>
            <p><strong>El. paštas:</strong> asistentas@gmail.com</p>
            <p><strong>Telefonas:</strong> +370 633 37939</p>
            <p><strong>Pašto adresas:</strong> A. Smetonos g. 3-32, Vilnius, Lietuva 01115</p>
            <p><strong>Darbo laikas:</strong> Pr-Pt 9:00-18:00</p>
          </div>

          <div style={{ marginTop: '2rem', padding: '1.5rem', background: '#f0f8ff', borderRadius: '8px', border: '1px solid #b6d7ff', textAlign: 'center' }}>
            <p style={{ marginBottom: '1rem' }}><strong>📧 Klausimų dėl duomenų apsaugos?</strong></p>
            <a href="/kontaktai" style={{
              display: 'inline-block',
              padding: '0.75rem 1.5rem',
              background: '#1976d2',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '6px',
              fontWeight: '600',
              transition: 'all 0.3s ease'
            }} onMouseOver={(e) => (e.target as HTMLElement).style.background = '#1565c0'} onMouseOut={(e) => (e.target as HTMLElement).style.background = '#1976d2'}>
              Susisiekti su mumis
            </a>
          </div>
        </div>
      </div>
    </div>
  </Layout>
);

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* LEAD GEN SITE - Main Pages */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/kontaktai" element={<Kontaktai />} />
          <Route path="/privatumo-politika" element={<PrivatumoPolitika />} />
          <Route path="/naudojimosi-salygos" element={<NaudojimosiSalygos />} />

          {/* Admin Routes - Active */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/recording/:id" element={<RecordingDetail />} />
          <Route path="/admin/dashboard/*" element={<AdminDashboard />} />
          <Route path="/admin/user/:userId" element={<AdminUserProfile />} />

          {/* COMMENTED OUT FOR LEAD GEN - SaaS Routes */}
          {/*
          <Route path="/registracija" element={<MultiStepRegistration />} />
          <Route path="/kainos" element={<Kainos />} />
          <Route path="/pagalba" element={<Pagalba />} />
          <Route path="/prisijungti" element={<UserLogin />} />
          <Route path="/reset-password" element={<PasswordReset />} />
          <Route path="/verify-email" element={<EmailVerification />} />
          <Route path="/payment" element={<ProductPayment />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/first-purchase-success" element={<FirstPurchaseSuccess />} />
          <Route path="/topup-success" element={<TopUpSuccess />} />
          <Route path="/first-purchase-failure" element={<FirstPurchaseFailure />} />
          <Route path="/topup-failure" element={<TopUpFailure />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
          <Route path="/dashboard" element={<UserDashboard />} />
          <Route path="/dashboard/*" element={<UserDashboard />} />
          <Route path="/user-dashboard/:userId" element={<UserDashboard />} />
          <Route path="/recording/:id" element={<RecordingDetail />} />
          <Route path="/button-showcase" element={<ButtonShowcase />} />
          */}

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;